import { Coupon } from '@definitions/types/symfonyTypes'

export const dummyCouponData: Coupon[] = [
  {
    __typename: 'Coupon',
    id: '/api/coupons/018c87f6-4dbc-7ef2-ade9-62a379f40610',
    title: 'Coupon 1',
    subtitle: 'Example coupon subtitle',
    sort: 1,
    frontendImage: {
      __typename: 'MediaObject',
      id: '/api/media_objects/example',
      publicPath: '/sunpoint.svg',
    },
    affiliations: {
      __typename: 'AffiliationCursorConnection',
      edges: [
        {
          __typename: 'AffiliationEdge',
          node: {
            __typename: 'Affiliation',
            id: '/api/affiliations/018c87f6-4dca-78a6-8fc0-5d80f4b6f42d',
            name: 'Wellmaxx',
          },
        },
        {
          __typename: 'AffiliationEdge',
          node: {
            __typename: 'Affiliation',
            id: '/api/affiliations/018c87f6-4dca-78a6-8fc0-5d80f53d0b6a',
            name: 'Sunpoint',
          },
        },
      ],
    },
  } as Coupon,
]
